import { useFlipperFlag } from './useFlipperFlag'
import { useIsVirtualMarketer } from './useIsVirtualMarketer'

export const useIsScheduledPostsV3 = () => {
  const isScheduledPostsV3 = useFlipperFlag('scheduled_posts_v3')
  const isVirtualMarketer = useIsVirtualMarketer()
  return isScheduledPostsV3 && isVirtualMarketer
}
